import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ApiService } from '../../core/services/api.service';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { AccountConfiguration } from '../models/account-configuration.model';

@Injectable({
  providedIn: 'root',
})
export class AccountConfigurationService {
  public accountConfiguration$: Observable<AccountConfiguration>;
  private refresh$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private apiService: ApiService, private authStoreService: AuthStoreService) {
    this.accountConfiguration$ = this.refresh$.pipe(
      switchMap(() =>
        this.apiService.get<AccountConfiguration>(
          `/customers/${this.authStoreService.userInfo.customer_id}/account-scores`,
          null,
          true,
          'customer/account-scores',
          ([data, socketFrame]) => (socketFrame ? socketFrame : data),
        ),
      ),
    );
  }

  public finishConfiguration(accountConfiguration: AccountConfiguration): void {
    this.apiService
      .put(`/customers/${this.authStoreService.userInfo.customer_id}/account-scores/visibility`, accountConfiguration)
      .subscribe(() => {
        this.refreshConfiguration();
      });
  }

  public refreshConfiguration(): void {
    this.refresh$.next(true);
  }
}
